import { render, staticRenderFns } from "./SelectProps.vue?vue&type=template&id=77f3d881"
import script from "./SelectProps.vue?vue&type=script&lang=js"
export * from "./SelectProps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports